import React, { Component } from "react";
import {
  withRouter
} from 'react-router-dom';
import {
  Icon,
  Button,
  Text,
  Card,
  Collapsible,
} from "@shopify/polaris";
import {
  ChevronUpMinor,
  ChevronDownMinor,
} from '@shopify/polaris-icons';
import "./index.css";
import ToastFunc from "../ToastFunc";
import Language from '../../i18n/Language';
import { cloneDeep } from "lodash";
import utils from "../../utils/utils";
import ViewImage from "../ViewImage";
const t = Language;

class FaqCardBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FaqList: this.props.FaqList,

      //请求弹窗
      showToast: false,  //弹窗显示
      showToastText: '',  //弹窗文字
      showToastIserror: false, //弹窗是否错误
      openState: [], // 打开状态
      showMore: false, // 是否显示更多
      hasImg: this.props.hasImg,
      imgUrl: '',
    };
  }

  //点击联系客服
  handleContactService = () => {
    try {
      window.Willdesk.show()
    } catch (e) {
      this.toggleToast(t("Try again later"), true);
    }
  }

  // 打开
  openFaqItem = (item) => {
    let currentL = cloneDeep(this.state.openState);
    if (currentL.includes(item)) {
      currentL.splice(currentL.indexOf(item), 1);
    } else {
      currentL.push(item);
    }

    this.setState({
      openState: currentL
    })
  }

  // 查看更多
  viewMoreFaq = () => {
    this.setState({
      showMore: !this.state.showMore
    })
  }

  //提示弹窗
  toggleToast = (showToastText, showToastIserror, showState = true) => {
    // 判断提示方式
    const shopify = window.shopify;
    if (showToastText) {
      if (shopify) {
        shopify.toast.hide();
        let settings = {
          duration: 3000,
          isError: Boolean(showToastIserror)
        }
        if (showState) {
          shopify.toast.show(showToastText, settings);
        } else {
          shopify.toast.hide();
        }
      } else {
        this.setState({
          showToast: false
        }, () => {
          this.setState({
            showToast: showState,
            showToastText: showToastText || '',
            showToastIserror: showToastIserror || ''
          });
        });
      }
    }
  };

  // 预览图片
  viewImageShow = (src) => {
    this.setState({
      imgUrl: src,
    })
  }

  // 关闭
  closeImageShow = () => {
    this.setState({
      imgUrl: ''
    })
  }

  render() {
    const {
      FaqList,
      showToast,
      showToastText,
      showToastIserror,
      openState,
      showMore,
      hasImg,
      imgUrl,

    } = this.state;

    // 提示
    const toastMarkup = showToast ? <ToastFunc content={showToastText} onDismiss={showToast} error={showToastIserror} /> : null;

    return (<div>
      {
        Boolean(imgUrl) && <ViewImage imgUrl={imgUrl} closeImageShow={this.closeImageShow} />
      }
      {toastMarkup}
      <Card padding={100}>
        <div style={{ padding: '0.5rem 1rem 1rem' }}>
          <Text variant="headingMd" as="h6">{t("Frequently Asked Questions")}</Text>
          <Text as="p" tone="subdued" variant='bodyMd'>{t("If you have any questions you can")}&nbsp;<Button variant="plain" onClick={this.handleContactService}>{t("contact us")}</Button>&nbsp;{t("anytime")}</Text>
        </div>

        <div className="faq_box">
          {
            hasImg ? <div className="faq_box_img">
              <div className="faq_text_content">
                {
                  Object.keys(FaqList).map((item, index) => {
                    return <div key={`${item}_${index}`} className={`faq_top ${item}_${index}`} style={{ display: index > 4 && !showMore ? 'none' : '' }}>
                      <div className="faq_top_main">
                        {
                          item === "high_score" ? <div className="faq_box_title">
                            {t("What are the benefits of having a high")}
                            <span onClick={(e) => {
                              e.stopPropagation();
                              window.open("https://pagespeed.web.dev/");
                            }} className="jump_text">&nbsp;{t("Google Pagespeed Insights")}&nbsp;</span>
                            {t("score for a store?")}
                          </div> :
                            <div className="faq_box_title">
                              {t(FaqList[item].title)}
                            </div>
                        }
                      </div>
                      <p>
                        {t(FaqList[item].tag[0])}&nbsp;
                        {
                          FaqList[item].url ? <span className="jump_text">{FaqList[item].url}</span> : null
                        }
                      </p>
                    </div>
                  })
                }
              </div>
              <div className="faq_img_content">
                <img onClick={() => this.viewImageShow(hasImg)} className='local-business zoom-in' src={hasImg} alt='' />
              </div>
            </div> :
              Object.keys(FaqList).map((item, index) => {
                return <div key={`${item}_${index}`} className={`faq_top faq_col ${item}_${index}`} style={{ display: index > 4 && !showMore ? 'none' : '' }}>
                  <div className="faq_top_main" onClick={() => this.openFaqItem(item)}>
                    {
                      item === "high_score" ? <div className="faq_box_title">
                        {/* {Number(index) + 1}.  */}
                        {t("What are the benefits of having a high")}
                        <span onClick={(e) => {
                          e.stopPropagation();
                          window.open("https://pagespeed.web.dev/");
                        }} className="jump_text">&nbsp;{t("Google Pagespeed Insights")}&nbsp;</span>
                        {t("score for a store?")}
                      </div> :
                        <div className="faq_box_title">
                          {/* {Number(index) + 1}.  */}
                          {t(FaqList[item].title)}
                        </div>
                    }
                    <Icon source={!openState.includes(item) ? ChevronDownMinor : ChevronUpMinor} color='base' />
                  </div>
                  <Collapsible
                    open={openState.includes(item)}
                    id={`${item}-collapsible`}
                    transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                    expandOnPrint
                  >
                    <div style={{ marginBottom: '1rem' }}>
                      {
                        FaqList[item].tag.map(sons => {
                          return item === "OnPageSEO" ? <p className="faq_box_desc" key={`${item}_li`}>
                            {t("SEOAnt has integrated with ChatGPT, allowing our")}&nbsp;
                            <Button variant="plain" onClick={() => {
                              utils.routeJump(this, "/on-page-seo");
                            }}>{t("AI writer")}</Button>&nbsp;
                            {t("to automatically generate content to help you resolve all of your On-Page SEO issues.")}
                          </p> :
                            item === "AddCodeSEOant" ? <p className="faq_box_desc" key={`${item}_li`}>
                              {t("Only the")}&nbsp;<Button variant="plain" onClick={() => {
                                utils.routeJump(this, "/speedOpt/site-speedup");
                              }}>{t("Site speed up")}</Button>&nbsp;{t("function will add code to your website, but it doesn't matter, it will not have any other impact on your website. If you turn off the function, the code will be deleted immediately.")}
                            </p> :
                              item === "wd_amp" ? <p className="faq_box_desc" key={`${item}_li`}>
                                {t("Use the official AMP testing tool provided by the AMP project")}&nbsp;
                                (<Button variant="plain" onClick={() => { window.open("https://search.google.com/test/amp") }}>{t("https://search.google.com/test/amp")}</Button>)&nbsp;
                                {t("to test the effectiveness of AMP pages. You can submit the URL of an AMP page to the testing tool, and it will simulate Google's search engine parsing and rendering process for AMP pages, providing relevant errors and warnings.")}
                              </p> :
                                item === "hd_JSON" ? <p className="faq_box_desc" key={`${item}_li`}>
                                  {t("Various online tools or browser extensions can be used to validate the syntax and structure of JSON-LD data to ensure it can be correctly parsed and understood by search engines. The URL for the tool is")}&nbsp;
                                  <Button variant="plain" onClick={() => { window.open("https://search.google.com/test/rich-results") }}>{t("https://search.google.com/test/rich-results")}</Button>.
                                </p> :
                                  item === "htv_local" ? <p className="faq_box_desc" key={`${item}_li`}>
                                    {t("Various structured data testing tools or the Google Structured Data Testing Tool can be used to validate the syntax and structure of Local Business JSON-LD. The URL for the tool is")}&nbsp;
                                    <Button variant="plain" onClick={() => { window.open("https://search.google.com/test/rich-results") }}>{t("https://search.google.com/test/rich-results")}</Button>.
                                  </p> :
                                    item === "ii_diff" ? <p className="faq_box_desc" key={`${item}_li`}>
                                      {t(sons)}&nbsp;
                                      <Button variant="plain" onClick={() => { window.open("https://developers.google.com/search/apis/indexing-api/v3/quickstart?hl=zh-cn") }}>{t("Google instant index")}</Button>
                                    </p> :
                                      item === "so_long_speed" ? <p className="faq_box_desc" key={`${item}_li`}>
                                        {t("The effects are usually immediate. You can use")}&nbsp;
                                        <Button variant="plain" onClick={() => { window.open("https://pagespeed.web.dev/") }}>{t("PageSpeed Insights")}</Button>&nbsp;
                                        {t("to reassess the loading times of your optimized pages and observe changes in website traffic and user behavior improvements.")}
                                      </p> :
                                        <p key={sons} className="faq_box_desc">{t(sons)}</p>
                        })
                      }
                    </div>
                  </Collapsible>
                </div>
              })
          }
        </div>
        {
          Object.keys(FaqList).length > 5 && <div className="faq_viewmore">
            <Button onClick={this.viewMoreFaq}>{!showMore ? t("View more") : t("View less")}</Button>
          </div>
        }
      </Card>
    </div>
    );
  }
}

export default withRouter(FaqCardBox);
